import React, {useMemo} from 'react';
import {NavLink} from 'react-router-dom';
import {FlagFilled} from '@ant-design/icons';
import {Tag, theme, Typography} from 'antd';
import {ReactComponent as Calendar} from 'assets/images/calendar.svg';
import {dateFormat, dateHoursFormat, timeFormat} from 'helpers/formats';
import {areDatesDayEqual} from 'helpers/utils';
import {AppRoutePaths} from 'routing/Routes';
import {getStatusColor} from 'views/serviceActions/utils/ServicesUtils';
import {ServiceActionDto} from '../../../../../PRMGApiClient';

interface ServiceBoxProps {
  service: ServiceActionDto;
  className?: string;
}

export const ServiceBox: React.FC<ServiceBoxProps> = ({
  service: {id, name, description, status, required, startDateTime: startDate, endDateTime: endDate},
}) => {
  const {token} = theme.useToken();

  const date = useMemo(() => {
    if (areDatesDayEqual(startDate, endDate)) {
      return `${dateFormat(startDate)} | ${timeFormat(startDate)} - ${timeFormat(endDate)}`;
    } else {
      return `${dateHoursFormat(startDate)} - ${dateHoursFormat(endDate)}`;
    }
  }, [startDate, endDate]);

  return (
    <NavLink to={AppRoutePaths.services.url + `/${id}`}>
      <div
        className="flex flex-col gap-2 p-2 border w-full hover:shadow-lg hover:scale-125 hover:cursor-pointer"
        style={{borderColor: token[getStatusColor(status)], borderRadius: token.borderRadiusLG}}
      >
        <div className="flex justify-between">
          <h3 className="text-black font-semibold">
            {name} {required && <FlagFilled style={{color: token.red}} />}
          </h3>
          <Tag color={getStatusColor(status)} className="mr-0">
            {status}
          </Tag>
        </div>

        {description && <Typography.Text type="secondary">{description}</Typography.Text>}
        <div className="flex gap-2 items-center">
          <Calendar className="h-4 w-4" />
          <span className="text-12 leading-4 text-darkGray">{date}</span>
        </div>
      </div>
    </NavLink>
  );
};
